var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#youtube_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.165 0 0 7.165 0 16s7.165 16 16 16 16-7.165 16-16S24.835 0 16 0Zm9.998 16.016s0 3.245-.412 4.81a2.505 2.505 0 0 1-1.762 1.762C22.258 23 16 23 16 23s-6.242 0-7.823-.428a2.506 2.506 0 0 1-1.763-1.763C6.002 19.261 6.002 16 6.002 16s0-3.245.412-4.81a2.556 2.556 0 0 1 1.763-1.778C9.74 9 16 9 16 9s6.259 0 7.823.428c.857.23 1.532.906 1.763 1.763.428 1.564.412 4.825.412 4.825Z",
    fill: "#474A57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.398 18.659 5.204-2.652-5.204-2.652v5.304Z",
    fill: "#474A57"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "youtube_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#fff"
  })))));
};
export default SvgYoutube;